import { Service } from '@app-types/service.type';
import FlatButton from '@components/flat-button/flat-button';
import { useServicesStore } from '@stores/services-store';

import { PlanItem } from '../plan-item/plan-item';

import styles from './service-item.module.scss';

type Props = {
    service: Service;
    onCreatePlan: (serviceId: number) => void;
};

const ServiceCardDetails = ({ service, onCreatePlan }: Props) => {
    const { planFrequencies } = useServicesStore();

    return (
        <div className={styles.serviceDetails}>
            <div className={styles.header}>
                <h4>Planes disponibles</h4>
                <FlatButton
                    style={{
                        padding: '4px 6px',
                        fontSize: 12,
                        borderRadius: 4,
                    }}
                    onClick={() => onCreatePlan(service.id)}
                >
                    + Añadir Plan
                </FlatButton>
            </div>
            <div className={styles.planList}>
                {service.plans?.length === 0 ? (
                    <span className={styles.noPlans}>
                        No hay planes disponibles
                    </span>
                ) : (
                    service.plans?.map((plan) => (
                        <PlanItem
                            key={plan.id}
                            plan={plan}
                            frequency={
                                planFrequencies.find(
                                    (f) => f.id === plan.frequencyId
                                )!
                            }
                        />
                    ))
                )}
            </div>
        </div>
    );
};

export { ServiceCardDetails };
